// @owners { team: patients-team }
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { type Event } from '~shared/lib/analytics/src/types';

export const generateSendPrescriptionOptionsViewedEvent = (origin: string): Event =>
  createEvent(EVENTS.SEND_PRESCRIPTION_OPTIONS_VIEWED, {
    origin,
  });
